module.exports = __webpack_public_path__ + "media/images/icons/icon_calender-a4b18bf0747d26baf9e01b52d1ee3eb2.svg";